/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CourseDto
 */
export interface CourseDto {
  /**
   *
   * @type {string}
   * @memberof CourseDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CourseDto
   */
  name: string;
}

export function CourseDtoFromJSON(json: any): CourseDto {
  return CourseDtoFromJSONTyped(json, false);
}

export function CourseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function CourseDtoToJSON(value?: CourseDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
